module.exports = __webpack_public_path__ + "static/img/windows_var.2eb15db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/c/images/windows_var.png
// module id = Z+2z
// module chunks = 1